import { computed, effect, Injectable, signal } from '@angular/core';
import { User } from '../administration/users/user.model';

const STORAGE_KEY = 'viewAsUser';

@Injectable({ providedIn: 'root' })
export class ViewAsService {
  private _viewedUser = signal<User | null>(this.loadFromStorage());

  readonly viewedUser = this._viewedUser.asReadonly();
  readonly viewedUserId = computed(() => this._viewedUser()?.id ?? null);
  readonly isViewingAsOther = computed(() => this._viewedUser() !== null);
  readonly isReadOnly = computed(() => this.isViewingAsOther());

  constructor() {
    effect(() => {
      const user = this._viewedUser();
      this.saveToStorage(user);
    });
  }

  setViewedUser(user: User | null): void {
    this._viewedUser.set(user);
  }

  clearViewedUser(): void {
    this._viewedUser.set(null);
  }

  getQueryParams(): { user_id?: number } {
    const userId = this.viewedUserId();
    return userId ? { user_id: userId } : {};
  }

  private loadFromStorage(): User | null {
    try {
      const stored = localStorage.getItem(STORAGE_KEY);
      if (stored) {
        const data = JSON.parse(stored);
        return new User(data);
      }
    } catch {
      localStorage.removeItem(STORAGE_KEY);
    }
    return null;
  }

  private saveToStorage(user: User | null): void {
    if (user) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(user));
    } else {
      localStorage.removeItem(STORAGE_KEY);
    }
  }
}
